import { Link } from "gatsby";
import * as React from "react";
import { Col, Container, Row } from 'react-bootstrap';
import { useStaticQuery, graphql } from 'gatsby'
import { GatsbyImage, getImage } from "gatsby-plugin-image";

// import GMFlag from '../images/country/gm.svg';
// import HTFlag from '../images/country/ht.svg';

const CaseStudiesList = (props) => {

    const title = props.title;
    const description = props.description;
    const sectionClass = props.sectionClass;

    const { allCasestudyJson } = useStaticQuery(graphql`
    query CaseStudyList {
        allCasestudyJson(sort: {date: DESC}) {
            edges {
                node {
                    id
                    date(formatString: "MMMM DD, YYYY")
                    slug
                    title    
                    excerpt
                    categories    
                    boundlessOpportunities {
                        title
                        text1
                    }
                    seo {
                        socialImage {
                            childImageSharp {
                                gatsbyImageData(width: 720)
                            }
                        }
                    }
                }
            }
        }
    }
  `)

    // allMdx(
    //     sort: { frontmatter: { date: DESC } }
    //     filter: { frontmatter: { categories: { eq: "Case Studies" } } } 
    //     limit: 1
    //     ) {
    //     edges {
    //     node {
    //         id
    //         fields {
    //         slug
    //         }
    //         excerpt(pruneLength: 180)
    //         frontmatter {
    //         date(formatString: "MMMM DD, YYYY")
    //         title
    //         socialImage {
    //             childImageSharp {
    //             gatsbyImageData(width: 720)
    //             }
    //         }
    //         }
    //     }
    //     }
    // }

    // const posts = allMdx.edges
    const postsJson = allCasestudyJson?.edges

    return (
        <>
            <section className={`blog-list-section section ${sectionClass}`}>
                <Container className="py-5">
                    <div className="w-75">
                        <div className="section-title mb-5 pb-1">
                            <h2 className="heading fw-semibold mb-4">
                                {title}
                            </h2>
                            <p className="lead">{description}</p>
                        </div>
                    </div>

                    {postsJson.map(
                        (item, index) =>
                            index < 2 && (
                                <div key={index} className="case-studies-row">
                                    <Row className="justify-content-between g-5">
                                        <Col lg={6}>
                                            <div className="case-studies-image">
                                                <GatsbyImage loading='lazy' width={720} height={400} image={getImage(item.node?.seo?.socialImage)} alt='featured' />
                                            </div>
                                        </Col>
                                        <Col lg={6}>
                                            <div className="case-studies-content">
                                                <p className="case-meta d-flex align-items-center justify-content-between text-muted mb-3">
                                                    {item.node?.boundlessOpportunities?.filter((_, i) => i === 0).map((item, index) => (
                                                        <span key={index} className="fw-medium hover-primary">{item.text1}</span>
                                                    ))}
                                                    <span>Under NDA</span>
                                                </p>
                                                <h2 className="heading h3 mb-3 font-size-28" dangerouslySetInnerHTML={{
                                                    __html: item.node.title
                                                }} />
                                                <p className="mb-4 font-size-16" dangerouslySetInnerHTML={{
                                                    __html: item.node.excerpt
                                                }} itemProp="description" />

                                                {item.node?.boundlessOpportunities?.filter((_, i) => i === 1 || i === 2).map((item, index) => (
                                                    <Row key={index} className={`row ${index === 2 ? "mb-4-lg" : 'mb-2'}`}>
                                                        <Col xs={4}>
                                                            <span className="fw-medium">{item.title}</span>
                                                        </Col>
                                                        <Col xs={8}>
                                                            <div className="country d-flex align-items-center">
                                                                {item.text1}
                                                                {/* {item.node.id === "97fa2941-5610-5df5-9fcb-497b3f74a4e8" ? (
                                                                    <>
                                                                        <Image loading="lazy" className="lazyload" src={GMFlag} alt="flag" width={24} height={18} />
                                                                        Gambia
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        <Image loading="lazy" className="lazyload" src={HTFlag} alt="flag" width={24} height={18} />
                                                                        {item.text1}
                                                                    </>
                                                                )} */}
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                ))}
                                                <Link to={`/case-studies/${item.node.slug}`} aria-label="Explore more" className="btn btn-primary-theme btn-primary-theme-outline mt-4"><span>Explore more <i className="icon ms-2 zmdi zmdi-hc-lg zmdi-arrow-right"></i></span></Link>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            )
                    )}

                    {/* {posts.map(
                        (post, index) =>
                            index < 1 && (
                                <div key={index} className="case-studies-row">
                                    <Row className="justify-content-between g-5">
                                        <Col lg={6}>
                                            <div className="case-studies-image">
                                                <GatsbyImage loading='lazy' width={720} height={400} image={post.node.frontmatter?.socialImage?.childImageSharp.gatsbyImageData} alt='featured' />
                                            </div>
                                        </Col>
                                        <Col lg={6}>
                                            <div className="case-studies-content">
                                                <p className="case-meta d-flex align-items-center justify-content-between text-muted mb-3">
                                                    <span className="fw-medium hover-primary">FinTech</span>
                                                    <span>Under NDA</span>
                                                </p>
                                                <h2 className="heading h3 mb-3 font-size-28">{post.node.frontmatter.title}</h2>
                                                <p className="mb-4 font-size-16" dangerouslySetInnerHTML={{
                                                    __html: post.node.frontmatter.description || post.node.excerpt,
                                                }} itemProp="description" />
                                                <Row className="row mb-2">
                                                    <Col xs={4}>
                                                        <span className="fw-medium">Country</span>
                                                    </Col>
                                                    <Col xs={8}>
                                                        <div className="country d-flex align-items-center">
                                                            {post.node.id === "1e8bd45a-5b55-5559-839a-fb201bd37660" ? (
                                                                <>
                                                                    <Image loading="lazy" className="lazyload" src={GMFlag} alt="flag" width={24} height={18} />
                                                                    Gambia
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <Image loading="lazy" className="lazyload" src={HTFlag} alt="flag" width={24} height={18} />
                                                                    Haiti
                                                                </>
                                                            )}
                                                        </div>
                                                    </Col>
                                                </Row>
                                                <Row className="mb-4-lg">
                                                    <Col xs={4}>
                                                        <span className="fw-medium">Solution</span>
                                                    </Col>
                                                    <Col xs={8}>
                                                        <div className="d-flex align-items-center">
                                                            e-Wallet
                                                        </div>
                                                    </Col>
                                                </Row>
                                                <Link to={post.node.fields.slug} aria-label="Explore more" className="btn btn-primary-theme btn-primary-theme-outline"><span>Explore more <i className="icon ms-2 zmdi zmdi-hc-lg zmdi-arrow-right"></i></span></Link>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            )
                    )} */}
                    <div className="text-center">
                        <Link to="/case-studies" className="btn btn-link">
                            <span>view more case studies</span> <i className="icon ms-2 zmdi zmdi-hc-lg zmdi-long-arrow-right"></i>
                        </Link>
                    </div>
                </Container>
            </section>
        </>
    )
}

CaseStudiesList.defaultProps = {
    title: "DigiPay.Guru’s success over the years",
    description: "Over the years, DigiPay.Guru has successfully delivered several customized and top-notch digital wallet solutions for its clients. You can get a glimpse of a few of those works here.",
    sectionClass: ''
}

export default CaseStudiesList;
